(function () {
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function saveResumeState() {
    var pid = getParam('pid');
    var handle = getParam('handle');
    if (!pid && !handle) return;
    try {
      if (pid) localStorage.setItem('crazytall_resume_pid', pid);
      if (handle) localStorage.setItem('crazytall_resume_handle', handle);
    } catch (e) {
      /* localStorage unavailable — ignore */
    }
  }

  function fireBeginTrialEvent(plan, pid) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'begin_trial_click', { plan: plan, pid: pid || undefined });
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'begin_trial_click', plan: plan, pid: pid || undefined });
      }
    } catch (e) {
      /* tracking not configured — ignore */
    }
  }

  class MembershipPlanPicker extends HTMLElement {
    connectedCallback() {
      this.variantId = this.dataset.variantId;
      this.plans = {
        annual: this.dataset.annualPlanId,
        monthly: this.dataset.monthlyPlanId,
      };
      this.radios = this.querySelectorAll('input[name="membership_plan"]');
      this.cta = this.querySelector('.membership-hero__cta');

      var requestedPlan = getParam('plan');
      if (requestedPlan === 'monthly') {
        var monthlyRadio = this.querySelector('#MembershipPlan-Monthly');
        if (monthlyRadio) monthlyRadio.checked = true;
      }

      this.radios.forEach(
        function (radio) {
          radio.addEventListener('change', this.updateHref.bind(this));
        }.bind(this)
      );

      this.updateHref();

      this.cta.addEventListener(
        'click',
        function () {
          saveResumeState();
          fireBeginTrialEvent(this.selectedPlan(), getParam('pid'));
        }.bind(this)
      );

      // Carry the return-to-product context through to sign-in too.
      var signInLink = document.getElementById('MembershipSignInLink');
      var pid = getParam('pid');
      if (signInLink && pid) {
        var url = new URL(signInLink.href, window.location.origin);
        url.searchParams.set('return_url', window.location.pathname + window.location.search);
        signInLink.href = url.toString();
      }
    }

    selectedPlan() {
      var checked = this.querySelector('input[name="membership_plan"]:checked');
      return checked ? checked.value : 'annual';
    }

    updateHref() {
      var plan = this.selectedPlan();
      var sellingPlanId = this.plans[plan];
      var params = new URLSearchParams();
      params.set('id', this.variantId);
      params.set('quantity', '1');
      params.set('selling_plan', sellingPlanId);
      params.set('return_to', '/checkout');

      var pid = getParam('pid');
      var handle = getParam('handle');
      var title = getParam('title');
      if (pid) params.set('pid', pid);
      if (handle) params.set('handle', handle);
      // Real cart attributes (not just query params) — these are what the
      // Thank You page checkout extension reads to show "continue shopping".
      if (handle) params.set('attributes[crazytall_origin_handle]', handle);
      if (title) params.set('attributes[crazytall_origin_title]', title);

      this.cta.href = '/cart/add?' + params.toString();
    }
  }

  customElements.define('membership-plan-picker', MembershipPlanPicker);
})();
